<template>
	<div>
		<catalog-picker-component 
			:disabled="disabled" 
			auth
			v-model="selectedVehicle"
			:placeholder="placeholder ? placeholder : 'Поиск автомобилей по марке, модели, VIN'"
			search-url="/api/vehicles/search"
			emit-change-event
			:show-suffix="true"
			:suffix-icon="filterIcon"
			@change="onSelectChange">
			<template #label>
				<div v-if="selectedVehicle?.id">
					<span style="float: left">{{ `${selectedVehicle.model?.manufacturer?.name} ${selectedVehicle.model?.name}` }}</span>
					<span style="float: right; color: var(--el-text-color-secondary); font-size: .8rem">
						{{ selectedVehicle.vin }}
					</span>
				</div>
			</template>
			<template #default="scope">
				<div>
					<span style="float: left">
						{{ scope.model?.manufacturer?.name }} {{ scope.model?.name }}						
						<el-text size="small" type="info">
							{{ scope.counterparty.lastname }} {{ scope.counterparty.firstname }}
						</el-text>
					</span>
					<span style="float: right; color: var(--el-text-color-secondary); font-size: .8rem">
						{{ scope.vin }}
					</span>
				</div>
			</template>
		</catalog-picker-component>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import CatalogPickerComponent from '../CatalogPickerComponent.vue';
import Vehicle from '@/models/Vehicle';
import { Filter } from '@element-plus/icons-vue';

@Options({	
	components: {
		CatalogPickerComponent
	},
	props: {
		disabled: Boolean,
		placeholder: String
	},
	emits: ['selected'],
})
export default class VehicleFilterComponent extends Vue {
	/** props */
	disabled!: boolean;
	placeholder!: string

	/** constants */
	filterIcon = Filter;

	/** view-models */
	selectedVehicle: Vehicle | null = null;	

	onSelectChange() {
		this
			.$nextTick()
			.then(() => this.$emit('selected', this.selectedVehicle));
	}
}
</script>